/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './Header.css';
import { useContent } from '../../context/ContentContext';

const NAME_HOLD_MS = 5000;

/* Cycles through the given strings, ignoring any that are blank in Airtable. */
const useAlternatingText = (values) => {
  const options = values.filter(Boolean);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (options.length < 2) {
      return undefined;
    }
    const timer = setInterval(
      () => setIndex((current) => (current + 1) % options.length),
      NAME_HOLD_MS,
    );
    return () => clearInterval(timer);
  }, [options.length]);

  return options[index % options.length] || '';
};

const Header = ({ history }) => {
  const { navigation, siteContent } = useContent();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const name = useAlternatingText([siteContent.home_name, siteContent.home_hindi_name]);

  const tabs = navigation
    .filter((item) => item.label && item.path && !item.hidden)
    .sort((a, b) => a.sortOrder - b.sortOrder);

  /* Prefix rather than equality, so /movies/other-movies keeps Movies marked. */
  const isActive = (path) => history.location.pathname.startsWith(path);

  const goTo = (path) => {
    history.push(path);
    setIsMenuOpen(false);
  };

  return (
    <div className="header">
      <div
        className="name"
        tabIndex={0}
        role="button"
        onKeyPress={() => history.push('/')}
        onClick={() => history.push('/')}
      >
        {/* Keyed on the text so each swap restarts the fade. */}
        <span className="name-text" key={name}>{name}</span>
      </div>
      <div className="header-right">
        <div className="menu">
          {tabs.map((tab) => (
            <div
              key={tab.path}
              className={isActive(tab.path) ? 'menu-item active' : 'menu-item'}
              onClick={() => goTo(tab.path)}
              tabIndex={0}
              role="button"
              onKeyPress={() => goTo(tab.path)}
            >
              {tab.label}
            </div>
          ))}
        </div>
        <div className="social-media-black">
          <a className="menu-wrapper" href={siteContent.social_instagram_url}>
            <FontAwesomeIcon icon={faInstagram} className="header-icon" />
          </a>
          <a className="menu-wrapper" href={`mailto:${siteContent.social_email}`}>
            <FontAwesomeIcon icon={faEnvelope} className="header-icon" />
          </a>
        </div>
      </div>
      <button
        type="button"
        className="menu-icon"
        onClick={() => setIsMenuOpen(true)}
      >
        <svg viewBox="0 0 100 80" width="30" height="30">
          <rect width="100" height="8" fill="black" />
          <rect y="30" width="100" height="8" fill="black" />
          <rect y="60" width="100" height="8" fill="black" />
        </svg>
      </button>
      {
        isMenuOpen ? (
          <div className="mobile-menu">
            <div className="header header-white">
              <div
                className="name-black"
                tabIndex={0}
                role="button"
                onKeyPress={() => history.push('/')}
                onClick={() => history.push('/')}
              >
                <span className="name-text" key={name}>{name}</span>
              </div>
              <button type="button" className="close-icon" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faTimes} size="1x" />
              </button>
            </div>
            <div className="menu-options">
              {tabs.map((tab) => (
                <div
                  key={tab.path}
                  className="menu-item"
                  onClick={() => goTo(tab.path)}
                  tabIndex={0}
                  role="button"
                  onKeyPress={() => goTo(tab.path)}
                >
                  {tab.label}
                </div>
              ))}
            </div>
            <div className="social-media">
              <a href={siteContent.social_instagram_url}>
                <FontAwesomeIcon icon={faInstagram} className="header-icon" size="3x" />
              </a>
              <a href={`mailto:${siteContent.social_email}`}>
                <FontAwesomeIcon icon={faEnvelope} className="header-icon" />
              </a>
            </div>
          </div>
        )
          : null
      }
    </div>
  );
};

export default withRouter(Header);
